/* Blank PDP size grid (snippets/blanks-size-grid.liquid). Shows the selected colour's cells,
   keeps the button's running count and total current, and adds every size with a quantity in one
   /cart/add.js call. While it runs the button reads "Adding...". After it, an "Added to cart" toast
   drops in under the header cart icon (the way ninjapatches.com does it) with a View cart button
   whose fill counts down its 5 seconds, and the theme's refreshCart('notOpen') updates the cart
   count and drawer quietly instead of sliding the drawer open. A one-size style starts at 1.
   (Justin 2026-09-23) */
(function () {
  var root = document.querySelector('[data-bsg]');
  if (!root) return;
  var section = root.closest('[id^="shopify-section-"]') || document;
  var btn = root.querySelector('[data-bsg-add]');
  var note = root.querySelector('[data-bsg-note]');
  var groups = root.querySelectorAll('[data-bsg-color]');
  var LABEL = btn.textContent;

  function money(cents) { return '$' + (Math.round(cents) / 100).toFixed(2); }
  function qtyOf(input) { return parseInt(String(input.value).replace(/[^0-9]/g, ''), 10) || 0; }
  function visible() {
    for (var i = 0; i < groups.length; i++) if (!groups[i].hidden) return groups[i];
    return groups[0] || null;
  }
  function inputs() { var g = visible(); return g ? g.querySelectorAll('.bqb__qty') : []; }
  function setNote(text, isError) {
    note.textContent = text || '';
    note.classList.toggle('is-error', !!isError);
  }

  function refresh() {
    var list = inputs(), n = 0, total = 0;
    for (var i = 0; i < list.length; i++) {
      var q = qtyOf(list[i]);
      if (!q) continue;
      n += q;
      total += q * (parseInt(list[i].getAttribute('data-bqb-price'), 10) || 0);
    }
    btn.textContent = n ? 'Add ' + n + (n === 1 ? ' item - ' : ' items - ') + money(total) : LABEL;
    btn.classList.toggle('is-ready', n > 0);
  }
  /* empty boxes, except a lone in-stock size, which starts at 1 */
  function reset() {
    var list = inputs();
    for (var i = 0; i < list.length; i++) list[i].value = '';
    if (list.length === 1 && !list[0].disabled) list[0].value = '1';
    refresh();
  }
  function show(color) {
    var hit = false;
    for (var i = 0; i < groups.length; i++) {
      var on = groups[i].getAttribute('data-bsg-color') === color;
      groups[i].hidden = !on;
      if (on) hit = true;
    }
    if (!hit && groups[0]) groups[0].hidden = false;
    setNote('');
    reset();
  }

  function checkedColor() {
    var r = section.querySelector('.product-variant__item--color input[type="radio"]:checked');
    return r ? r.value : null;
  }

  section.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.product-variant__item--color')) show(e.target.value);
  });
  /* a click replaces the number instead of appending to it */
  function selectQty(e) {
    var q = e.target.closest && e.target.closest('.bqb__qty');
    if (q) { try { q.select(); } catch (err) {} }
  }
  root.addEventListener('focusin', selectQty);
  root.addEventListener('click', selectQty);
  root.addEventListener('input', function (e) {
    if (e.target.classList && e.target.classList.contains('bqb__qty')) { setNote(''); refresh(); }
  });
  root.addEventListener('click', function (e) {
    var step = e.target.closest('[data-bqb-step]');
    if (!step) return;
    var input = step.closest('.bqb__qtywrap').querySelector('.bqb__qty');
    if (!input || input.disabled) return;
    var q = qtyOf(input);
    q = step.getAttribute('data-bqb-step') === 'up' ? q + 1 : Math.max(0, q - 1);
    input.value = q ? String(q) : '';
    setNote('');
    refresh();
  });

  /* ── "Added to cart" toast under the header cart icon ── */
  var TOAST_MS = 5000;
  function place(t) {
    var icon = document.querySelector('.dtfhd-cart') ||
      (document.querySelector('[data-header-cart-count]') || {}).parentElement;
    var r = icon && icon.getBoundingClientRect ? icon.getBoundingClientRect() : null;
    var top = r && r.bottom > 0 ? r.bottom + 10 : 12;
    t.style.top = Math.round(top) + 'px';
    if (window.innerWidth >= 600 && r && r.width) {
      t.style.right = Math.max(12, Math.round(document.documentElement.clientWidth - r.right)) + 'px';
    }
  }
  function showAdded(info) {
    var old = document.querySelector('.bat');
    if (old) old.remove();
    var t = document.createElement('div');
    t.className = 'bat';
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');
    t.innerHTML =
      '<div class="bat__head">' +
        '<span class="bat__tick" aria-hidden="true"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12.5 4.2 4.2L19 7"/></svg></span>' +
        '<span class="bat__title">Added to cart</span>' +
        '<button type="button" class="bat__x" aria-label="Close"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
      '</div>' +
      '<div class="bat__item">' +
        '<span class="bat__imgwrap"><img class="bat__img" alt=""></span>' +
        '<div class="bat__txt"><p class="bat__name"></p><p class="bat__meta"><span class="bat__opts"></span><b class="bat__price"></b></p></div>' +
      '</div>' +
      '<a class="bat__view" href="/cart"><span class="bat__fill" aria-hidden="true"></span><span class="bat__label">View cart</span>' +
        '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>';
    var img = t.querySelector('.bat__img');
    if (info.image) img.src = info.image; else t.querySelector('.bat__imgwrap').remove();
    t.querySelector('.bat__name').textContent = info.name || '';
    t.querySelector('.bat__opts').textContent = info.opts || '';
    t.querySelector('.bat__price').textContent = info.price || '';
    t.style.setProperty('--bat-ms', TOAST_MS + 'ms');
    place(t);
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });

    var left = TOAST_MS, started = Date.now(), timer = null;
    function close() {
      clearTimeout(timer);
      t.classList.remove('is-in');
      setTimeout(function () { if (t.parentNode) t.remove(); }, 220);
    }
    function run() { started = Date.now(); timer = setTimeout(close, left); }
    t.addEventListener('mouseenter', function () {
      clearTimeout(timer); left = Math.max(0, left - (Date.now() - started)); t.classList.add('is-paused');
    });
    t.addEventListener('mouseleave', function () { t.classList.remove('is-paused'); run(); });
    t.querySelector('.bat__x').addEventListener('click', close);
    run();
  }
  function productImage() {
    var g = document.querySelector('.product-gallery .css-slider-holder img, .product-gallery img');
    return g ? (g.currentSrc || g.src) : '';
  }

  btn.addEventListener('click', function () {
    var list = inputs(), items = [];
    for (var i = 0; i < list.length; i++) {
      var q = qtyOf(list[i]);
      if (q > 0 && !list[i].disabled) items.push({ id: parseInt(list[i].getAttribute('data-bqb-id'), 10), quantity: q });
    }
    if (!items.length) { setNote('Choose a quantity for at least one size.', true); return; }

    var units = 0, cost = 0;
    for (var u = 0; u < list.length; u++) {
      var uq = qtyOf(list[u]);
      if (uq > 0 && !list[u].disabled) { units += uq; cost += uq * (parseInt(list[u].getAttribute('data-bqb-price'), 10) || 0); }
    }
    btn.disabled = true;
    btn.textContent = 'Adding...';
    setNote('');
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        btn.disabled = false;
        if (!res.ok) {
          refresh();
          setNote((res.data && res.data.description) || 'That could not be added.', true);
          return;
        }
        var first = (res.data && res.data.items && res.data.items[0]) || {};
        var color = checkedColor();
        showAdded({
          image: first.image || productImage(),
          name: first.product_title || '',
          opts: (color ? color + ' · ' : '') + 'Qty ' + units,
          price: money(cost)
        });
        reset();
        if (typeof window.refreshCart === 'function') window.refreshCart('notOpen');
      })
      .catch(function () {
        btn.disabled = false;
        refresh();
        setNote('Something went wrong. Please try again.', true);
      });
  });

  var start = checkedColor();
  if (start !== null) show(start); else reset();
})();
